import { useEffect } from 'react';

import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import {
  withButtonAlignment,
  withRtlSupport,
} from '@skyscanner-internal/backpack-web/bpk-component-icon';
import ArrowIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/long-arrow-right';
import {
  BpkBox,
  BpkStack,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkPanel from '@skyscanner-internal/backpack-web/bpk-component-panel';
import BpkText from '@skyscanner-internal/backpack-web/bpk-component-text';
import { logOperationalEvent } from 'saddlebag-logger';

import { useTranslation } from '../../helpers/hooks/useTranslation';

import ErrorPanelImage from './ErrorPanelImage';

const AlignedArrowIcon = withButtonAlignment(withRtlSupport(ArrowIcon));
export const FLIGHTS_ERROR_PANEL_LOADED = 'FLIGHTS_ERROR_PANEL_LOADED';

const ErrorPanel = ({
  helpUrl,
  reloadPage,
}: {
  helpUrl: string;
  reloadPage: () => void;
}) => {
  const translate = useTranslation();
  useEffect(() => {
    logOperationalEvent({ eventName: FLIGHTS_ERROR_PANEL_LOADED });
  }, []);
  return (
    <BpkPanel padded={false}>
      <BpkStack
        paddingBlock={BpkSpacing.Base}
        align="center"
        gap={BpkSpacing.None}
        marginTop={BpkSpacing.Base}
      >
        <ErrorPanelImage />
        <BpkStack
          direction="row"
          gap={BpkSpacing.SM}
          marginTop={BpkSpacing.MD}
          marginBottom={BpkSpacing.SM}
        >
          <BpkText>{translate('service_failure_heading')}</BpkText>
          <BpkText>{translate('service_failure_text')}</BpkText>
        </BpkStack>
        <BpkBox marginBottom={BpkSpacing.MD}>
          <BpkText>
            {translate('service_failure_pre_link')}{' '}
            <BpkLink href={helpUrl} target="_blank" rel="noopener noreferrer">
              {translate('service_failure_link')}
            </BpkLink>
          </BpkText>
        </BpkBox>
        <BpkButton onClick={reloadPage} type={BUTTON_TYPES.secondary}>
          <BpkBox as="span" marginEnd={BpkSpacing.SM}>
            <BpkText>{translate('service_failure_try_again_label')}</BpkText>
          </BpkBox>
          <BpkBox as="span" color="text-link">
            <AlignedArrowIcon />
          </BpkBox>
        </BpkButton>
      </BpkStack>
    </BpkPanel>
  );
};

export default ErrorPanel;
